import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import {getPetZodiacPersonalityDescription} from "../../actions/medicalRecords";
import _ from "lodash";

const $ = window.$;
const DESCRIPTION_ORDER = {
  INTRO : 'intro',
  DESCRIPTION : 'description',
  ZODIAC :  'zodiac',
  DELIVERY : 'delivery',
  OUTRO : 'outro',
}

class OpenAiPetZodiacDescriptionSuggestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAiZodiacDescription:'',   
      descriptionZodiac : '',
      zodiacTemp : '',  
      loadingPetZodiacDescription: false,
    };
  }

  changeVal = event => {
      let value = event.target.value;
      this.setState({[event.target.name]: value });
  };

  selectZodiacDescription = () => {
    const description = this.state.openAiZodiacDescription;  
    this.props.parentPetZodiacDescriptionCallback(description);
    $("#pet_zodiac_description_suggestion-modal").modal("hide"); 
   }

   retryZodiacDescriptionGenerate = () => {
    this.setState({ loadingPetZodiacDescription : true,});
    this.resetInfo();
    this.props.getPetZodiacPersonalityDescription(this.state.petZodiacDescriptionPrompt);
   }


   resetInfo(){
    this.setState({
      openAiZodiacDescription : '',
    });
   } 


  componentDidMount() {  
  }

  componentWillReceiveProps = nextProps => {
    if(nextProps.petZodiacDescriptionPrompt && this.props.petZodiacDescriptionPrompt !== nextProps.petZodiacDescriptionPrompt ){           
       this.setState({ loadingPetZodiacDescription: true });
       $("#pet_zodiac_description_suggestion-modal").modal("show");
       this.resetInfo();
       this.props.getPetZodiacPersonalityDescription(nextProps.petZodiacDescriptionPrompt);
    }

    if( nextProps.suggestedPetZodiacDescription && this.props.suggestedPetZodiacDescription !== nextProps.suggestedPetZodiacDescription){      
      let descriptionInfo = nextProps.suggestedPetZodiacDescription;
      this.setState({
        openAiZodiacDescription: descriptionInfo.message,    
        loadingPetZodiacDescription : false,
      });    
    }

    if( this.props.suggestedPetZodiacDescriptionError !== nextProps.suggestedPetZodiacDescriptionError){ 
      this.setState({ openAiZodiacDescription : '', loadingPetZodiacDescription : false, });    
      if(nextProps.suggestedPetZodiacDescriptionError && nextProps.suggestedPetZodiacDescriptionError.message && !_.isEmpty(nextProps.suggestedPetZodiacDescriptionError.message)){  
          NotificationManager.error(nextProps.suggestedPetZodiacDescriptionError.message);      
      }else{
        NotificationManager.error("An error occurred while loading the zodiac description");
      }
      $("#pet_zodiac_description_suggestion-modal").modal("hide");
    } 
  };

  render() {
    const {loadingPetZodiacDescription, openAiZodiacDescription} = this.state;
    return (
    <div
      className="modal fade show"
      id="pet_zodiac_description_suggestion-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ConfirmationModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Puppy Zodiac Description
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body"> 
           { !loadingPetZodiacDescription ?            
          <>
            <div className="row">
              <div className="form-control m-portlet m-portlet--full-height ">						
                <div className="m-portlet__body">  
                <div className="row">
                    <textarea
                        className="form-control m-input"
                        name="openAiZodiacDescription"
                        onChange={this.changeVal}
                        value={openAiZodiacDescription}
                        id="exampleTextarea"
                        rows="4"
                    ></textarea>
                </div>
                <div className='d-flex justify-content-end'>                                
              <div>
                <span className='pet-description-word-count'>{openAiZodiacDescription && openAiZodiacDescription.trim().length > 0 ? openAiZodiacDescription.trim().length: 0}/500</span>
              </div>
            </div>  
                </div>
              </div>
            </div> 
            <div className="row justify-content-left mb-2">        
              <a className="btn btn-warning m-btn btn-sm m-btn--icon m-btn--pill ml-4"
                 onClick={()=> this.retryZodiacDescriptionGenerate()}   
              >
              <span>
                <i className="fa fa-redo-alt"></i>
                <span>Retry</span>
                </span>
              </a>     
            </div>
          </>:
              <div className="row justify-content-center">
                <div className="col-2">
                      <Loader size={25} />
                </div>
              </div>
            }
          </div>
          <div className="modal-footer">
            <div>
              <button
                type="button"
                className="btn btn-secondary m-btn--pill mx-2"
                data-dismiss="modal"
              >
                Cancel
                </button>
              <button
                type="button"
                onClick={() => this.selectZodiacDescription()}
                className="btn btn-primary m-btn--pill"
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  suggestedPetZodiacDescription: state.medicalRecordsReducer.suggestedPetZodiacDescription,
  suggestedPetZodiacDescriptionError: state.medicalRecordsReducer.suggestedPetZodiacDescriptionError,
});

const mapDispatchToProps = dispatch => ({
  getPetZodiacPersonalityDescription: (data) => {
    dispatch(getPetZodiacPersonalityDescription(data))
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OpenAiPetZodiacDescriptionSuggestion)
  );